import React, { useCallback, useState, useEffect } from 'react';
import { Modal, Button } from 'antd';
import s from './s.module.less';
import { InsuranceSetting } from 'types/common';
import commonS from 'styles/common.module.less';
import StateInsuranceCard from 'pages/NewUniProfile/components/InsuranceStep/components/StateInsuranceCard';

interface InsuranceCarrierModalProps {
    visible: boolean;
    onCancel: () => void;
    onSave: (allInsuranceSettings: Record<string, InsuranceSetting>) => void;
    states: string[];
    initialInsuranceSettings?: Record<string, InsuranceSetting>;
    isOps?: boolean;
    openState?: string;
    showPayerId?: boolean;
}

const InsuranceCarrierModal: React.FC<InsuranceCarrierModalProps> = ({
    visible,
    onCancel,
    onSave,
    states,
    initialInsuranceSettings,
    isOps = false,
    openState,
    showPayerId = false,
}) => {
    const [openCardState, setOpenCardState] = useState<string | null>(null);
    const [allInsuranceSettings, setAllInsuranceSettings] = useState<Record<string, InsuranceSetting>>(() => {
        const settings: Record<string, InsuranceSetting> = {};
        states.forEach((state) => {
            settings[state] = initialInsuranceSettings?.[state] || {
                state,
                carriers: [],
                otherCarriers: '',
            };
        });
        return settings;
    });

    useEffect(() => {
        if (openState) {
            setOpenCardState(openState);
        }
    }, [openState]);

    useEffect(() => {
        if (initialInsuranceSettings) {
            setAllInsuranceSettings(initialInsuranceSettings);
        }
    }, [initialInsuranceSettings]);

    const handleInsuranceChange = (insurance: InsuranceSetting) => {
        setAllInsuranceSettings((prev) => ({
            ...prev,
            [insurance.state]: insurance,
        }));
    };

    const handleSave = () => {
        onSave(allInsuranceSettings);
    };

    const toggleCardState = useCallback((state: string) => {
        setOpenCardState((prev) => (prev === state ? null : state));
    }, []);

    return (
        <Modal
            title="Manage Insurance Carriers and Plans"
            open={visible}
            onCancel={onCancel}
            width={1000}
            className={`${s.modal} ${commonS.modalFixHeightWrap}`}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="save" type="primary" onClick={handleSave}>
                    Save All
                </Button>,
            ]}
            destroyOnClose
        >
            <div className={s.container}>
                {states.map((state) => (
                    <div key={state} className={s.stateSection}>
                        <StateInsuranceCard
                            state={state}
                            insurance={allInsuranceSettings[state]}
                            onChange={handleInsuranceChange}
                            onToggle={() => toggleCardState(state)}
                            isOpen={openCardState === state}
                            isOps={isOps}
                            showPayerId={showPayerId}
                        />
                    </div>
                ))}
            </div>
        </Modal>
    );
};

export default InsuranceCarrierModal;
